module.exports = __webpack_public_path__ + "img/104.799e0e87.png";